module.exports = __webpack_public_path__ + "static/media/tracker-number.02400042.svg";